import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { applyRegion, environment } from "../../environments/environment";

@Injectable({
    providedIn: "root"
})
export class ContactService {
    contactUrl = environment.apiUrl + "contact";

    constructor(private http: HttpClient) { }

    async createContactMessage(name: string, email: string, message: string) {
        const body = { name, email, message };
        const httpOptions = {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        const urls = [
            environment.heroku + 'api/contact',
            applyRegion(this.contactUrl, environment.renderRegions.oregon),
            applyRegion(this.contactUrl, environment.renderRegions.frankfurt)
        ]

        for (const link of urls) {
            try {
                return await this.http.post<ContactResponse>(link, body, httpOptions)
                    .pipe(catchError(this.handleError))
                    .toPromise();
            } catch (error) {
                continue
            }
        }
        throw new Error("No backend was reached :(");
    }

    private handleError(error: HttpErrorResponse) {
        if (error.status === 0) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error("A client-side or network error occurred:", error.error);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // Return an observable with a user-facing error message.
        return throwError(
            {
                msg: "Something bad happened; please try again later.",
                status_code: error.status
            });
    }
}

export interface ContactResponse {
    error: string;
    success: boolean;
}
